/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */
import type { GetFlightsParams, PagedResponseFlightResponse } from '../models';

export type getFlightsResponse200 = {
    data: PagedResponseFlightResponse;
    status: 200;
};

export type getFlightsResponse400 = {
    data: void;
    status: 400;
};

export type getFlightsResponse500 = {
    data: void;
    status: 500;
};

export type getFlightsResponseSuccess = getFlightsResponse200 & {
    headers: Headers;
};

export type getFlightsResponseError = (getFlightsResponse400 | getFlightsResponse500) & {
    headers: Headers;
};

export type getFlightsResponse = getFlightsResponseSuccess | getFlightsResponseError;

export const getGetFlightsUrl = (params?: GetFlightsParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(
                key,
                value === null
                    ? 'null'
                    : value instanceof Date
                      ? value.toISOString()
                      : value.toString()
            );
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0
        ? `/api/v1/flights?${stringifiedParams}`
        : `/api/v1/flights`;
};

export const getFlights = async (
    params?: GetFlightsParams,
    options?: RequestInit
): Promise<getFlightsResponse> => {
    const res = await fetch(getGetFlightsUrl(params), {
        ...options,
        method: 'GET'
    });

    const body = [204, 205, 304].includes(res.status) ? null : await res.text();

    const data = (body !== null ? body : '') as unknown as getFlightsResponse['data'];

    return { data, headers: res.headers, status: res.status } as getFlightsResponse;
};
